import { ArticleItem, ArticleItemInput } from 'data/generated/graphql';
import { AllessehContent } from 'hooks/useAllessehContentQuery';

export const prepContent = (content: AllessehContent, originContentType: string, originId: string) => {
  const {
    attributes: { product, seo_id: seoId, canonical_url: canonicalUrl, source_url: sourceUrl, content_status: status }
  } = content.data;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const normalizedSeoId = seoId ?? '';

  return {
    product,
    seo_id: originContentType === 'commerceproduct' ? '' : normalizedSeoId,
    hosted_url: canonicalUrl || sourceUrl,
    status,
    base_doc_id: originId,
    originContentType,
    originId,
    id: originId,
    link: originContentType === 'commerceproduct' ? '' : `api/articles/v1/originid/${originId}`
  };
};

export const prepContentItems = (contentItem: ArticleItem): ArticleItemInput => {
  const { originContentType, originId } = contentItem.attributes;
  const { content } = contentItem;

  const typeSafeOriginContentType = typeof originContentType === 'string' ? originContentType : '';

  const typeSafeContent = typeof content === 'string' ? content : JSON.stringify(content);
  const parsedContent = JSON.parse(typeSafeContent) as AllessehContent;

  const {
    attributes: { product, seo_id: seoId, canonical_url: canonicalUrl, source_url: sourceUrl, content_status: status }
  } = parsedContent.data;

  return {
    attributes: {
      product,
      seo_id: typeSafeOriginContentType === 'commerceproduct' ? '' : seoId,
      hosted_url: canonicalUrl || sourceUrl,
      status,
      base_doc_id: originId ?? '',
      originContentType: typeSafeOriginContentType,
      originId: originId ?? '',
      id: originId ?? '',
      link: typeSafeOriginContentType === 'commerceproduct' ? '' : `api/articles/v1/originid/${originId}`
    }
  };
};
